export default {
  'cookies.accept_all': (state) => {
    state.marketing = true
    state.personalization = true
    state.analytics = true
  },

  'cookies.decline_all': (state) => {
    state.marketing = false
    state.personalization = false
    state.analytics = false
  },

  'cookies.set': (state, {cookie, value}) => {
    state[cookie] = value
  }
}
